import { ReactNode } from 'react';

import type { VoucherListItem } from '../types';

interface VoucherModalManagerProps {
  data: VoucherListItem[];
  onSuccess: () => void;
  children: (props: {
    onAdd: () => void;
    onEdit: (id: string) => void;
    onDuplicate: (id: string) => void;
  }) => ReactNode;
}

export function VoucherModalManager({
  data,
  onSuccess,
  children,
}: VoucherModalManagerProps) {
  const handleAdd = () => {
    // TODO: Implement modal open logic
    console.log('Add voucher clicked');
  };

  const handleEdit = (id: string) => {
    // TODO: Implement edit modal logic
    const voucher = data.find((v) => v.id === id);
    console.log('Edit voucher:', voucher);
  };

  const handleDuplicate = (id: string) => {
    // TODO: Implement duplicate modal logic
    const voucher = data.find((v) => v.id === id);
    console.log('Duplicate voucher:', voucher);
  };

  return (
    <>
      {children({
        onAdd: handleAdd,
        onEdit: handleEdit,
        onDuplicate: handleDuplicate,
      })}

      {/* TODO: Add VoucherModal component when ready */}
    </>
  );
}
